import { Tab } from "bootstrap";
import { ReactNode, useEffect, Fragment } from "react";

export const DataContent = (props: { placeholder: ReactNode; children: ReactNode; data: unknown }) => {
    const { placeholder, children, data } = props;

    // show content
    useEffect(() => {
        if (data) {
            Tab.getOrCreateInstance("#tab-content").show();
        }
    }, [data]);

    return (
        <Fragment>
            <ul className="nav nav-tabs d-none">
                <li className="nav-item">
                    <button
                        id="tab-loading"
                        type="button"
                        className="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#panel-loading"
                    >
                        Loading
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        id="tab-content"
                        type="button"
                        className="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#panel-content"
                    >
                        Content
                    </button>
                </li>
            </ul>

            <div className="tab-content">
                <div id="panel-loading" className="tab-pane fade show active">
                    <div className="grid gap-lg-5">{placeholder}</div>
                </div>

                <div id="panel-content" className="tab-pane fade pb-5">
                    <div className="grid gap-lg-5">{data != null && children}</div>
                </div>
            </div>
        </Fragment>
    );
};
